import React, { useEffect, useRef } from 'react';
import { css } from '@emotion/react';
import theme from '@styles/theme';

interface IRegisterLayoutProp {
  title: string;
  infoText: string;
  children: JSX.Element[] | JSX.Element;
  isVisible?: boolean;
}

const RegisterLayout = ({
  title,
  infoText,
  isVisible = true,
  children,
}: IRegisterLayoutProp) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const visibilityStyle = css`
    display: ${isVisible ? 'block' : 'none'};
  `;

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <div css={[container, visibilityStyle]}>
      <h1 className="title">{title}</h1>
      {children}
    </div>
  );
};

const container = css`
  width: 100%;

  .title {
    margin-top: 1rem;
    font: ${theme.font.title1};
    color: ${theme.colors.gray900};
  }

  .info-text {
    margin-top: 1rem;
    font: ${theme.font.body2Normal};
    color: ${theme.colors.gray600};
  }
`;

export default RegisterLayout;
